import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    standalone: false,
    selector: 'wl-experience-select',
    template: `<ion-button (click)="prev()" [disabled]="experienceLevel === 0">&lt;</ion-button>
        <div class="label">
            {{ xpLabels[experienceLevel] | translate }}
        </div>
        <ion-button (click)="next()" [disabled]="experienceLevel === xpLabels.length - 1">&gt;</ion-button> `,
    styles: [
        `
            :host {
                display: flex;
                width: 100%;
                align-items: center;
            }
            .label {
                flex: 1 1 auto;
                text-align: center;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExperienceSelectComponent {
    @Input()
    experienceLevel: number;

    @Input()
    xpLabels = ['GLOBAL.EXPERIENCE.INEXPERIENCED', 'GLOBAL.EXPERIENCE.REGULAR', 'GLOBAL.EXPERIENCE.EXPERIENCED'];

    @Output()
    experienceChanged = new EventEmitter<number>();

    constructor() {}

    next() {
        this.experienceChanged.emit(this.experienceLevel + 1);
    }

    prev() {
        this.experienceChanged.emit(Math.max(this.experienceLevel - 1, 0));
    }
}
